<template>
  <div class="pb-2">
    <h4 class="alert alert-danger col-6 offset-3 font-weight-bold text-center"
        v-if="posters.length < 1 && loader === false">
      Sorry we could not load a poster.<br>
      Try a different search term or contact our support.
    </h4>
    <loader v-if="loader === true"></loader>
    <span v-if="loader === false && mode.grouped.status === true">
      <groupedCompactWall v-bind:posters="posters"
                          v-if="mode.displayType === 'wall' && mode.grouped.compact === true"></groupedCompactWall>
      <groupedWall v-bind:posters="posters" v-else-if="mode.displayType === 'wall'"></groupedWall>
      <groupedCard v-bind:posters="posters" v-else-if="mode.displayType === 'cards'"></groupedCard>
    </span>
    <span v-else-if="loader === false && mode.grouped.status === false">
      <listWall v-bind:posters="posters" v-if="mode.displayType === 'wall'"></listWall>
      <listCard v-bind:posters="posters" v-else-if="mode.displayType === 'cards'"></listCard>
    </span>
    <div class="fixed-bottom d-flex">
      <a href="#" v-scroll-to="'#top'" class="ml-auto mr-4 mb-4" title="Scroll to top">
        <icon :icon="['fad', 'arrow-circle-up']" class="fa-2x text-primary"/>
      </a>
    </div>
  </div>
</template>
<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    import groupedWall from "../components/grouped/groupedWall";
    import groupedCompactWall from "../components/grouped/groupedCompactWall";
    import groupedCard from "../components/grouped/groupedCard";
    import listWall from "../components/list/listWall";
    import listCard from "../components/list/listCard";

    import Loader from '../components/Loader';

    const VueScrollTo = require('vue-scrollto');
    export default {
        data: function () {
            return {
                search: ''
            }
        },
        components: {
            'groupedWall': groupedWall,
            'groupedCard': groupedCard,
            'groupedCompactWall': groupedCompactWall,
            'listWall': listWall,
            'listCard': listCard,
            Loader
        },
        computed: {
            ...mapState([
                'posters', 'mode', 'fullscreen', 'loader'
            ]),
        },
        methods: {
            setMode(mode) {
                this.$store.state.mode.displayType = mode;
            },
            doSearch() {
                this.$store.state.loader = true;
                this.$store.dispatch('GET_ALL_RATINGS');
                if (this.search.length > 0) {
                    let searchObject = {search: this.search, mode: this.$store.state.mode}
                    this.$store.dispatch('GET_POSTERS', searchObject);
                } else {
                    this.$store.dispatch('GET_ALL_POSTERS', this.$store.state.mode);
                }
            },
            resetSearch() {
                this.search = '';
                this.doSearch();
            }
        },
        created() {
            this.$store.state.fullscreen = false;
            this.$store.state.presentationSite = null;
        }
    }
</script>

<style>
  div.btn-group.btn-group-sm button.btn.btn-outline-primary.btn-sm {
    width: 1.8rem;
  }
</style>
